import { useEffect, useRef, useState } from "react";

export const FitWordmark = ({ text = "DANO BARS" }) => {
  const ref = useRef(null);
  const [box, setBox] = useState("0 0 1000 160");

  useEffect(() => {
    let alive = true;
    const measure = () => {
      const b = ref.current?.getBBox();
      if (alive && b?.width) setBox(`${b.x} ${b.y} ${b.width * 1.01} ${b.height}`);
    };
    measure();
    document.fonts?.ready?.then(measure);
    return () => { alive = false; };
  }, [text]);

  return (
    <svg viewBox={box} className="block h-auto w-full" data-testid="footer-wordmark" role="img" aria-label="DanoBars">
      <text ref={ref} x="0" y="0" fill="currentColor" className="font-wide" style={{ fontSize: 200 }}>{text}</text>
    </svg>
  );
};
